import React, { useContext} from 'react'
import './Report.scss'
import MyContext from '../Context/MyContext'

const Report = () => {

  const { usertoken } = useContext(MyContext)
  const domain = usertoken?.domain || ''
 

  const reports = [
    {
      domain: 'ai-ml',
      files: [
     
      ]
    },
    {
      domain: 'data-science',
      files: [
     
      ]
    },
    {
      domain: 'mern-stack',
      files: [
        { name: 'MERN Stack Report 1', file: '/Reports/mernstack/HIMIL_FINAL.pdf' },
       
      ]
    },
    {
      domain: 'full-stack',
      files: [
        { name: 'Full Stack Report 1', file: '/Reports/FullStack/nandani.pdf' },
        { name: 'Full Stack Report 2', file: '/Reports/FullStack/vansh.pdf' },
          { name: 'Full Stack Report 3', file: '/Reports/FullStack/visa.pdf' },
      ]
    },
    {
      domain: 'data-analysis',
      files: [
        { name: 'Data Analysis Report 1', file: '/Reports/DataAnalysis/dev panchal.pdf' },
        { name: 'Data Analysis Report 2', file: '/Reports/DataAnalysis/Jeel Patel Report.pdf' },
         { name: 'Data Analysis Report 3', file: '/Reports/DataAnalysis/Swar Report.pdf' },
         { name: 'Data Analysis Report 4', file: '/Reports/DataAnalysis/patha_shoiab.pdf' },
      ]
    },
    {
      domain: 'python',
      files: [
       
      ]
    },
    {
      domain: 'cyber-security',
      files: [
        { name: 'Cyber Security Report 1', file: '/Reports/cyber_security/parantap.pdf' },
        { name: 'Cyber Security Report 2', file: '/Reports/cyber_security/ronak.pdf' },
        { name: 'Cyber Security Report 3', file: '/Reports/cyber_security/VISA.pdf' },
       
      ]
    },
    {
      domain: 'app-development',
      files: [
      
      ] 
    },
  ]

  // ✅ Find matching domain report
  const matchedReport = reports.find(
    (report) => report.domain === domain
  )

  return (
    <div className="report">
    

    {!domain && <p>Please Update Your Profile Settings.</p>}

{domain && !matchedReport && (
  <p>No reports found for domain: <b>{domain}</b></p>
)}

{domain && matchedReport && matchedReport.files.length === 0 && (
  <p>No files available for your domain: <b>{domain}</b>.</p>
)}

{domain && matchedReport && matchedReport.files.length > 0 && (
  <ul className="report__grid">
    {matchedReport.files.map((file, index) => (
      <li key={index} className="report__item">
        <span>{file.name}</span>
        <a
          href={file.file}
          download={file.name}
          target="_blank"
          rel="noopener noreferrer"
          className="report__download"
        >
          Download
        </a>
      </li>
    ))}
  </ul>
)}

    </div>
  )
}

export default Report
